export const SET_ORGANIZATION_SUB_FUNDS = 'subFund/SET_ORGANIZATION_SUB_FUNDS';
export const SET_PAGINATION_META = 'subFund/SET_PAGINATION_META';
export const SET_ORGANIZATION_FILTER_SUB_FUNDS =
  'subFund/SET_ORGANIZATION_FILTER_SUB_FUNDS';
export const SET_APPLIED_SUB_FUND_FILTER =
  'subFund/SET_APPLIED_SUB_FUND_FILTER';
